import { Input } from '@/components/Input';
import { selectVisaNumber, setVisaNumber } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'VisaNumber';

export function VisaNumber({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const visaNumber = useAppSelector(selectVisaNumber);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        // MAXIMUM
        const MAXIMUM = 999;
        if (value.toLocaleString()?.length > 3) return;
        const intValue = getNumber(value, MAXIMUM);
        if (intValue === visaNumber) return;
        dispatch(setVisaNumber(intValue));
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title='Visa Number'
                placeholder='Visa Number'
                showErrors={
                    showErrors &&
                    (visaNumber === undefined ||
                        visaNumber === 0 ||
                        visaNumber.toString().length < 3)
                }
                onChange={handleChange}
                id={`${baseId}-input-residencyStatus-visaHolder-visaNumber`}
                value={visaNumber?.toLocaleString() ?? ''}
                tooltipContent='What type of visa do you have?'
            />
        </div>
    );
}
